import { $ } from '../utils/dom.js';
import { getActiveSheet, setActiveSheet, ALL_SHEETS } from '../sheetsStore.js';
import { getSheetCurrency } from '../currencyStore.js';
import { state } from '../state.js';
import { splitSheets } from '../api/sheetsList.js';

let _list = []; // [{ name, gid }] — solo VENTAS (sin hoja de costos)
let _failed = false;
let _discovered = false; // true cuando el discovery ya resolvió (con o sin éxito)

/**
 * Repobla el <select id="sheetSelect"> con la lista actual de hojas
 * descubiertas del Google Sheet.
 */
export function renderSheetSelect() {
  const sel = $('sheetSelect');
  if (!sel) return;

  sel.innerHTML = '';

  // Opción agregada — solo se ofrece si hay 2+ hojas detectadas.
  if (_list.length >= 2) {
    const allOpt = document.createElement('option');
    allOpt.value = ALL_SHEETS;
    allOpt.textContent = `Todas las hojas (${_list.length})`;
    sel.appendChild(allOpt);
  }

  const defaultOpt = document.createElement('option');
  defaultOpt.value = '';
  defaultOpt.textContent = 'Hoja por defecto';
  sel.appendChild(defaultOpt);

  _list.forEach(({ name }) => {
    const opt = document.createElement('option');
    opt.value = name;
    opt.textContent = `${name} · ${getSheetCurrency(name)}`;
    sel.appendChild(opt);
  });

  if (_failed && _list.length === 0) {
    const opt = document.createElement('option');
    opt.value = '';
    opt.textContent = '(no se pudieron detectar hojas)';
    opt.disabled = true;
    sel.appendChild(opt);
  }

  // Si la hoja activa ya no existe en el sheet (y no es el modo agregado),
  // fallback a default.
  const active = getActiveSheet();
  if (active && active !== ALL_SHEETS && _list.length && !_list.some((s) => s.name === active)) {
    setActiveSheet('');
    sel.value = '';
  } else if (active === ALL_SHEETS && _discovered && _list.length < 2) {
    // Quedó "Todas" guardado pero ya no hay 2+ hojas → fallback a default.
    // Solo aplica con el discovery resuelto: antes de eso la lista siempre
    // está vacía y borraríamos la selección guardada en cada recarga.
    setActiveSheet('');
    sel.value = '';
  } else {
    sel.value = active || '';
  }
}

export function setSheetsList(list) {
  // Separar VENTAS de COSTOS: el dropdown y __ALL__ solo deben ver ventas.
  const { salesSheets, costsSheet } = splitSheets(Array.isArray(list) ? list : []);
  _list = salesSheets;
  _failed = false;
  _discovered = true;
  // Compartido con loadData() y la vista general vía state — evita imports
  // circulares.
  state.knownSheets = _list.slice();
  state.costsSheet = costsSheet;
  renderSheetSelect();
}

export function setSheetsListError() {
  _list = [];
  _failed = true;
  _discovered = true;
  renderSheetSelect();
}

export function bindSheetSelect(onChange) {
  const sel = $('sheetSelect');
  if (!sel) return;
  sel.onchange = () => {
    setActiveSheet(sel.value);
    if (typeof onChange === 'function') onChange(sel.value);
  };
}
